import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NoSalesQuotationModel, SalesModuleApiSuffixModels, loggedInUserData } from '@app/modules';
import { AppState } from '@app/reducers';
import {
    CrudService, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix,
    RxjsService, setRequiredValidator
} from '@app/shared';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
@Component({
    selector: 'no-sales-up-pop-up',
    templateUrl: './no-sales-pop-up.component.html'
})

export class NoSalesPopUpComponent implements OnInit {
    noSalesQuotationForm: FormGroup;
    loggedInUserData: LoggedInUserModel;
    outcomeReasonId = "";
    isCometetorShow = true;
    promotionOfferShow = false;
    newsLetterShow = false;
    motivations = [];
    newsLetterTypes = [];
    data:any;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig,
        private crudService: CrudService,
        private formBuilder: FormBuilder,
        private store: Store<AppState>, private rxjsService: RxjsService) {
        this.data = config?.data;
    }

    ngOnInit(): void {
        this.rxjsService.setDialogOpenProperty(true);
        this.combineLatestNgrxStoreData();
        this.createLssResourceForm();
        this.getMotivation();
    }

    combineLatestNgrxStoreData() {
        combineLatest([this.store.select(loggedInUserData)]).subscribe((response) => {
            this.loggedInUserData = new LoggedInUserModel(response[0]);
        });
    }

    getMotivation() {
        this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.SALES_API_UX_MOTIVATION_REASON,
            undefined, false, null).subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode === 200 && response.resources) {
                    this.motivations = response.resources;
                    this.getNewsLetterTypes();
                }
            });
    }

    radioChange(e) {
        if (e.value) {
            this.isCometetorShow = true;
            this.noSalesQuotationForm.controls['competitorName'].setValidators([Validators.required]);
            this.noSalesQuotationForm.controls['outcomeReasonId'].setValidators([Validators.required]);
            this.noSalesQuotationForm.controls['isCustomerNotBuyFromCompetitor'].setValue(false);
        } else {
            this.isCometetorShow = false;
            this.noSalesQuotationForm.controls['competitorName'].setValue(null);
            this.noSalesQuotationForm.controls['competitorName'].clearValidators();
            this.noSalesQuotationForm.controls['competitorName'].updateValueAndValidity();
            this.noSalesQuotationForm.controls['outcomeReasonId'].setValue(null);
            this.noSalesQuotationForm.controls['outcomeReasonId'].clearValidators();
            this.noSalesQuotationForm.controls['outcomeReasonId'].updateValueAndValidity();
            this.noSalesQuotationForm.controls['isCustomerNotBuyFromCompetitor'].setValue(true);
        }
    }

    showOptions(e) {
        if (e.checked) {
            this.promotionOfferShow = true;
            this.noSalesQuotationForm.controls['promotionalOfferNewsLetterTypeId'].setValidators([Validators.required]);
        } else {
            this.promotionOfferShow = false;
            this.noSalesQuotationForm.controls['promotionalOfferNewsLetterTypeId'].setValue(null);
            this.noSalesQuotationForm.controls['promotionalOfferNewsLetterTypeId'].clearValidators();
            this.noSalesQuotationForm.controls['promotionalOfferNewsLetterTypeId'].updateValueAndValidity();
        }
    }

    showNewsOptions(e) {
        if (e.checked) {
            this.newsLetterShow = true;
            this.noSalesQuotationForm.controls['newsLetterTypeId'].setValidators([Validators.required]);
        } else {
            this.newsLetterShow = false;
            this.noSalesQuotationForm.controls['newsLetterTypeId'].setValue(null);
            this.noSalesQuotationForm.controls['newsLetterTypeId'].clearValidators();
            this.noSalesQuotationForm.controls['newsLetterTypeId'].updateValueAndValidity()
        }
    }

    getNewsLetterTypes() {
        this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.SALES_API_UX_NEWS_LETTER_TYPES,
            undefined, false, null).subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode === 200 && response.resources) {
                    this.newsLetterTypes = response.resources;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            });
    }

    createLssResourceForm(): void {
        let noSalesQuotationModel = new NoSalesQuotationModel();
        if (noSalesQuotationModel.outcomeReasonId) {
            this.outcomeReasonId = noSalesQuotationModel.outcomeReasonId;
        }
        this.noSalesQuotationForm = this.formBuilder.group({});
        Object.keys(noSalesQuotationModel).forEach((key) => {
            this.noSalesQuotationForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId') ? new FormControl(this.loggedInUserData.userId) :
                new FormControl(noSalesQuotationModel[key]));
        });
        this.noSalesQuotationForm = setRequiredValidator(this.noSalesQuotationForm, ["competitorName", "outcomeReasonId"]);
    }

    onSubmit(): void {
        if (this.noSalesQuotationForm.invalid) {
            return;
        }
        this.noSalesQuotationForm.value.leadId = this.data?.leadId;
        this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_QUOTATION_OUTCOME_NO_SALE,
            this.noSalesQuotationForm.value).subscribe((response) => {
                if (response.isSuccess && response.statusCode === 200) {
                    this.ref.close(true);
                    this.noSalesQuotationForm.reset();
                }
            });
    }

    dialogClose() {
        this.ref.close(false);
    }

    ngOnDestroy() {
        this.rxjsService.setDialogOpenProperty(false);
    }
}
